import {Brick, registerBrick} from 'olympe';

export default class OGAddFilterToBody extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} body
     * @param {string} field
     * @param {*} value
     * @param {string} operator
     * @param {*} group
     * @param {function()} forwardEvent
     * @param {function(*)} setBody
     */
    update($, [body, field, value, operator, group], [forwardEvent, setBody]) {
        const newBody = {
            ...body,
            filters: [
                ...(body.filters ? body.filters : []),
                {
                    ...(field ? {field: field} : {}),
                    ...(value ? {value: value} : {value: ''}),
                    ...(operator ? {operator: operator} : {}),
                    ...(group ? {group: group} : {}),
                },
            ],
        };
        setBody(newBody);
        forwardEvent();
    }
}

registerBrick('019c95197e0e534afafa', OGAddFilterToBody);
